import { Component, OnInit } from '@angular/core';
import {AhmService} from "../../services/ahm.service";
import {DialogBodyComponent} from "../dialog/dialog-body/dialog-body.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {TranslateService} from "../../services/translate.service";

@Component({
  selector: 'app-left-panel',
  templateUrl: './left-panel.component.html',
  styleUrls: ['./left-panel.component.css']
})
export class LeftPanelComponent implements OnInit {

  // social
  clubhouseButtonLink = 'https://vm.tiktok.com/ZSJeke7gB/';
  clubhouseButtonImage = '../assets/images/clubhouse.png';
  tikTokButtonLink = 'https://vm.tiktok.com/ZSJeke7gB/';
  tikTokButtonImage = '../assets/images/tiktok.png';
  rideroButtonLink = 'https://ridero.ru/books/alphabet_of_the_human_mind/';
  rideroButtonImage = '../assets/images/button_ro_bw_1339.png';
  amazonButtonLink = 'https://www.amazon.com/dp/B0727Q6YKL';
  amazonButtonImage = '../assets/images/button_am_bw_1339.png';
  boomstarterButtonLink = 'https://boomstarter.ru/projects/niki/flagman_mirovoy_psihologii_-_azbuka_chelovecheskoy_psihiki?utm_source=ahm_site&utm_medium=ahm_book&utm_campaign=book_order&utm_content=1339';
  boomstarterButtonImage = '../assets/images/button_bs_bw_1339.png';
  instagramButtonLink = 'https://www.instagram.com/lifeplaning/';
  instagramButtonImage = '../assets/images/button_in_bw_1339.png';
  vkButtonLink = 'https://vk.com/niki_danilov';
  vkButtonImage = '../assets/images/button_vk_bw_1339.png';
  youtubeButtonLink = 'https://www.youtube.com/channel/UCRbi5fPwF2IZIh7Ho5nzVDA';
  youtubeButtonImage = '../assets/images/button_yt_bw_1339.png';
  fbButtonLink = 'http://facebook.com/NDanilov';
  fbButtonImage = '../assets/images/button_fb_bw_1339.png';

  constructor(private matDialog: MatDialog, private translate: TranslateService) { }

  // set color button for selected item
  setColorButton(button) {
    switch (button) {
      case 'tiktok': {
        this.tikTokButtonImage = '../assets/images/tiktok.png';
        break;
      }
      case 'ridero': {
        this.rideroButtonImage = '../assets/images/button_ro_color_1339.png';
        break;
      }
      case 'amazon': {
        this.amazonButtonImage = '../assets/images/button_am_color_1339.png';
        break;
      }
      case 'boomstarter': {
        this.boomstarterButtonImage = '../assets/images/button_bs_color_1339.png';
        break;
      }
      case 'instagram': {
        this.instagramButtonImage = '../assets/images/button_in_color_1339.png';
        break;
      }
      case 'vk': {
        this.vkButtonImage = '../assets/images/button_vk_color_1339.png';
        break;
      }
      case 'youtube': {
        this.youtubeButtonImage = '../assets/images/button_yt_color_1339.png';
        break;
      }
      case 'fb': {
        this.fbButtonImage = '../assets/images/button_fb_color_1339.png';
        break;
      }

    }
  }
  // set black and white button for selected item
  setBWButton(button){
    switch (button) {
      case 'tiktok': {
        this.tikTokButtonImage = '../assets/images/tiktok_bw.png';
        break;
      }
      case 'ridero': {
        this.rideroButtonImage = '../assets/images/button_ro_bw_1339.png';
        break;
      }
      case 'amazon': {
        this.amazonButtonImage = '../assets/images/button_am_bw_1339.png';
        break;
      }
      case 'boomstarter': {
        this.boomstarterButtonImage = '../assets/images/button_bs_bw_1339.png';
        break;
      }
      case 'instagram': {
        this.instagramButtonImage = '../assets/images/button_in_bw_1339.png';
        break;
      }
      case 'vk': {
        this.vkButtonImage = '../assets/images/button_vk_bw_1339.png';
        break;
      }
      case 'youtube': {
        this.youtubeButtonImage = '../assets/images/button_yt_bw_1339.png';
        break;
      }
      case 'fb': {
        this.fbButtonImage = '../assets/images/button_fb_bw_1339.png';
        break;
      }

    }
  }

  ngOnInit() {
    AhmService.prototype.setLeftPanelComponentLink(this);
    AhmService.prototype.translateComponent(this, 'app-left-panel');
  }

  openDialog(message, ...links) {
    let array: string[] = [];
    array.push(message);
    for (let link of links) {
      array.push(link);
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = array;
    this.matDialog.open(DialogBodyComponent, dialogConfig);
  }
}
